"use client"

import { FocusTrap } from "focus-trap-react"
import { Session } from "next-auth"

import TrackedLink from "@/components/ui/TrackedLink"

import IconFilePen from "../icons/IconFilePen"
import LogoutButton from "../LogoutButton"

export default function LoginDetailsPopupContent({
  displayName,
  session,
  updateMyInformationLink,
  email,
  phone,
  setOpen
}: {
  displayName?: string
  session?: Session | null
  updateMyInformationLink?: string
  email?: string
  phone?: string
  setOpen?: (open: boolean) => void
}) {
  return (
    <div>
      <div className="mb-6">
        {displayName && (
          <div className="lg:hidden">
            <p className="text-sm font-bold">Inloggad som</p>
            <p className="mb-2">{displayName}</p>
          </div>
        )}
        {(email || session?.user?.epostadress1) && (
          <>
            <p className="text-sm font-bold">E-postadress</p>
            <p
              className="mb-2 truncate"
              title={email || session?.user?.epostadress1}>
              {email || session?.user?.epostadress1}
            </p>
          </>
        )}
        {(phone || session?.user?.mobilnr) && (
          <>
            <p className="text-sm font-bold">Mobilnummer</p>
            <p className="mb-2">{phone || session?.user?.mobilnr}</p>
          </>
        )}
        <p className="text-sm font-bold">Kundnummer</p>
        <p className="mb-0">{session?.user?.ExternalId}</p>
      </div>
      <FocusTrap
        focusTrapOptions={{
          clickOutsideDeactivates: true,
          escapeDeactivates: true
        }}>
        <div className="flex flex-col gap-4">
          <TrackedLink
            tabIndex={0}
            href={updateMyInformationLink || ""}
            onClick={() => setOpen?.(false)}
            analyticsEventName="Nav Click"
            analyticsProps={{
              label: "Uppdatera mina uppgifter",
              href: updateMyInformationLink || ""
            }}
            className="text-sm text-purple inline-flex items-center gap-1 font-bold hover:text-purple-500 hover:underline">
            <IconFilePen />{" "}
            <span className="mt-1">Uppdatera mina uppgifter</span>
          </TrackedLink>
          <LogoutButton label="Logga ut" />
        </div>
      </FocusTrap>
    </div>
  )
}
